/**
 * Types related to keypad.
 *
 * @class types
 * @private
 * @memberof Mojito.Modules.Keypad
 */

/**
 * Numeric keypad buttons keys.
 *
 * @constant {Array<string>}
 * @default ['key1', 'key2', 'key3', 'key4', 'key5', 'key6', 'key7', 'key8', 'key9', 'key0', 'dot', 'done']
 * @private
 * @memberof Mojito.Modules.Keypad.types
 */
const KEYS = [
    'key1',
    'key2',
    'key3',
    'key4',
    'key5',
    'key6',
    'key7',
    'key8',
    'key9',
    'key0',
    'dot',
    'done',
];

/**
 * Compact keypad buttons keys.
 *
 * @constant {string[]}
 * @default ['key1', 'key2', 'key3', 'key4', 'key5', 'key6', 'key7', 'key8', 'key9', 'key0', 'dot']
 * @private
 * @memberof Mojito.Modules.Keypad.types
 */
const COMPACT_KEYS = KEYS.filter(key => key !== 'done');

/**
 * Keypad multipliers keys.
 *
 * @constant {Array<string>}
 * @default ['key1', 'key2', 'key3', 'key4']
 * @private
 * @memberof Mojito.Modules.Keypad.types
 */
const INCREASE_KEYS = ['key1', 'key2', 'key3', 'key4'];

/**
 * Keypad layout type indicators. Markup of buttons differentiate depending on Layout type.
 *
 * @enum {string}
 * @private
 * @memberof Mojito.Modules.Keypad.types
 */
const LAYOUT = {
    /** Narrow layout. */
    NARROW: 'narrow',
    /** Wide layout. */
    WIDE: 'wide',
};

export { LAYOUT, INCREASE_KEYS, COMPACT_KEYS, KEYS };
